import React from 'react';

export default function MapDetails({ map }) {

    let revisions = map.revisions.map(revision => {
        return (<><div>{revision.revisionNumber}</div>
            <div>{revision.createdAt}</div>
            <div>{revision.revisionDetails}</div>
        </>);
    });

    return (<div className="flex flex-col">
        <span className="mx-4 mt-4 mb-2 text-xl font-semibold">{map.description}</span>
        <div className="mx-4 mt-2 grid grid-cols-3">
            <div>Update #</div>
            <div>Date</div>
            <div>Details</div>
            {revisions}
        </div>
    </div>);
}